import React, { useState, useEffect, useRef } from "react";
import jwtDecode from "jwt-decode";

import CustomIcons from "../../../../components/icons/kIcons.component";
import {
  adminMenu,
  intMdAdminMenu,
  superAdminMenu,
} from "../../../../utilities/reducers/admincontext";

export default function NavMenu(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const activeRef = useRef(null);

  const getInitialMenu = () => {
    let baseMenu = adminType === 3
      ? intMdAdminMenu.menus
      : adminType === 2
        ? superAdminMenu.menus
        : adminMenu.menus;

    // Auto-expand parents of active path
    const activePath = window.location.pathname;
    const expandParents = (parentId, menuList) => {
      if (!parentId) return;
      const parentIndex = menuList.findIndex(m => m.id === parentId);
      if (parentIndex !== -1) {
        menuList[parentIndex].expand = true;
        expandParents(menuList[parentIndex].parent, menuList);
      }
    };

    const newMenu = JSON.parse(JSON.stringify(baseMenu)); // Deep copy
    const activeItem = newMenu.find(m => m.path === activePath);
    if (activeItem) {
      expandParents(activeItem.parent, newMenu);
    }

    return newMenu;
  };

  const [menu, setMenu] = useState(getInitialMenu());
  const [count, setCount] = useState(0);

  useEffect(() => {
    // If path changes, ensure parents are expanded
    const activePath = window.location.pathname;
    let newMenu = [...menu];
    let changed = false;

    const expandParents = (parentId) => {
      if (!parentId) return;
      const parentIndex = newMenu.findIndex(m => m.id === parentId);
      if (parentIndex !== -1 && !newMenu[parentIndex].expand) {
        newMenu[parentIndex].expand = true;
        changed = true;
        expandParents(newMenu[parentIndex].parent);
      }
    };

    const activeItem = newMenu.find(m => m.path === activePath);
    if (activeItem) {
      expandParents(activeItem.parent);
    }

    if (changed) {
      setMenu(newMenu);
      setCount(c => c + 1);
    }

    // Scroll active item into view
    setTimeout(() => {
      if (activeRef.current) {
        activeRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 100);
  }, [window.location.pathname]);

  const renderMenu = (child, leve) => {
    let level = leve + 1;
    return (
      <React.Fragment key={child.id}>
        {menu &&
          menu.map((sub, ind) => (
            <React.Fragment key={sub.id}>
              {sub.parent === child.id && (
                <>
                  <li
                    ref={window.location.pathname === sub.path ? activeRef : null}
                    className={
                      window.location.pathname === sub.path
                        ? `navlist active sub`
                        : `navlist sub`
                    }
                    onClick={(e) => handlepath(level, e, sub, ind)}
                    style={{ marginLeft: 10 * level }}
                  >
                    <CustomIcons iconName={sub.icon ?? "view"} />
                    {sub.name}
                    <>
                      {sub.child &&
                        (sub.expand ? (
                          <span className="putright">
                            <CustomIcons
                              iconName={"down"}
                              iconClass="iconclass"
                            />
                          </span>
                        ) : (
                          <span className="putright">
                            <CustomIcons iconName={"down"} />
                          </span>
                        ))}
                    </>
                  </li>
                  {sub.expand && <>{renderMenu(sub, level)}</>}
                </>
              )}
            </React.Fragment>
          ))}
      </React.Fragment>
    );
  };

  const handlepath = (level, e, item, ind) => {
    localStorage.setItem("activeId", item.id);
    if (item?.path) {
      props.history.push(item.path);
    } else {
      const newMenu = [...menu];
      newMenu[ind]["expand"] = item.expand ? false : true;
      setMenu(newMenu);
      setCount(count + 1);
    }
  };

  return (
    <div className="navbar">
      <div id="wrapper">
        <div className="sidebar">
          <ul className="sidebar-nav">
            {menu &&
              menu.map((item, index) => (
                <React.Fragment key={item.id}>
                  {!item.parent && (
                    <>
                      <li
                        ref={window.location.pathname === item.path ? activeRef : null}
                        className={
                          window.location.pathname === item.path
                            ? `navlist active`
                            : `navlist`
                        }
                        onClick={(e) => handlepath(0, e, item, index)}
                      >
                        <CustomIcons iconName={item.icon ?? "view"} />
                        {item.name}
                        <>
                          {item.child &&
                            (item.expand ? (
                              <span className="putright">
                                <CustomIcons
                                  iconName={"down"}
                                  iconClass="iconclass"
                                />
                              </span>
                            ) : (
                              <span className="putright">
                                <CustomIcons iconName={"down"} />
                              </span>
                            ))}
                        </>
                      </li>
                      {item.expand && <>{renderMenu(item, 0)}</>}
                    </>
                  )}
                </React.Fragment>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
